import {
  ODataHeader,
  ODataString,
  ODataBoolean,
  ODataDate,
} from "pbas-vue-components";

export default [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),

  new ODataHeader({
    title: "headers.users_management.name",
    type: new ODataString("UserName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.users_management.gateway_plan_id",
    type: new ODataString("PlanMemberships[]/NeospinMemberId,GatewayPlanId", {
      getString: (item) => {
        var res = "";
        if (item.PlanMemberships) {
          res = item.PlanMemberships.find((x) => x.NeospinMemberId !== null);
          if (res) {
            res = res.GatewayPlanId;
          }
        }
        return res;
      },
    }),
    sortable: false,
    visible: true,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.users_management.person_id",
    type: new ODataString("PlanMemberships[]/NeospinMemberId", {
      getString: (item) => {
        var res = "";
        if (item.PlanMemberships) {
          res = item.PlanMemberships.find((x) => x.NeospinMemberId !== null);
          if (res) {
            res = res.NeospinMemberId;
          }
        }
        return res;
      },
    }),
    sortable: false,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.users_management.account_created_date",
    type: new ODataDate("PlanMemberships[]/DateRegistered", {
      getString: (item) => {
        var res = false;
        if (item.PlanMemberships) {
          res = item.PlanMemberships.find((x) => x.NeospinMemberId !== null);
        }
        if (res) {
          res = res.DateRegistered.split("T")[0];
        }
        return res;
      },
    }),
    sortable: false,
    visible: true,
    searchable: true,
    version: 1,
    orderByKey: "PlanMemberships/DateRegistered",
  }),
  new ODataHeader({
    title: "headers.users_management.email_confirmed",
    type: new ODataBoolean("EmailConfirmed"),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.users_management.registration_completed",
    type: new ODataBoolean("PlanMemberships[]/IsRegistrationCompleted", {
      getValue: (item) => {
        var res = false;
        if (item.PlanMemberships) {
          res = item.PlanMemberships.find((x) => x.NeospinMemberId !== null);
          if (res) {
            res = res.IsRegistrationCompleted;
          }
        }
        return res;
      },
    }),
    sortable: false,
    visible: true,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.users_management.last_login",
    type: new ODataDate("LastLoginDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.users_management.person_id",
    type: new ODataString("PlanMemberships[]/Url", {
      getString: (item) => {
        var res = "";
        if (item.PlanMemberships) {
          res = item.PlanMemberships.find((x) => x.NeospinMemberId !== null);
          if (res) {
            res = res.Url;
          }
        }
        return res;
      },
    }),
    sortable: false,
    visible: false,
    searchable: false,
  }),
];
